/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-04-30 13:36:37
 * @LastEditors: Json Chen
 * @LastEditTime: 2022-06-14 17:11:20
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelLegal/LegalPageEditor/SeoSetting/index.tsx
 */
import CountWords from '@/src/components/CountWords/CountWords';
import ItemWrapper from '@/src/components/Layouts/Item/Item';
import Row from '@/src/components/Layouts/Row/Row';
import { SectionContent } from '@/src/layout/EditorPageLayout/EditorCollapsePageLayout';
import React from 'react';
//import css from './css.module.less';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { Input, TextArea } from 'src/components/Antd';
import { isPrimaryLanguage } from 'src/constrains/SalesChannelMultiLanguageSelect/slice';
import Slug from 'src/constrains/SlugInput';
import { useI18n } from 'src/hooks/useRouterChange';
import SectionHOC from 'src/pages/SalesCannelVersion/SalesChannelLegal/Components/HOC';
import {
  EnumCollapseId,
  getCollapse,
  getSeoSetting,
  onCollapseChange,
  onSeoSettingChange,
} from 'src/pages/SalesCannelVersion/SalesChannelLegal/LegalPageEditor/slice';
import { NEW } from 'src/tools/constant';
import { getI18nFromGeneral, i18nGet } from 'src/tools/tools';
import { legalPermissions } from '../../Components/hooks/permission';
const SeoSetting = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const _data: any = useSelector(getSeoSetting());
  const _p: { uuid: string; legalPageUuid: string } = useParams();
  const { uuid, legalPageUuid } = _p;
  const _d = useDispatch();

  const { canEdit } = legalPermissions(uuid);

  const {
    title,
    description,
    urlSlug,
    slugValid,
    //isNameDuplicate
  } = _data || {};
  const isPrimary = useSelector(isPrimaryLanguage());
  const handleOnTitleChange = (title) => {
    _d(onSeoSettingChange({ title }));
  };
  const handleOnDescriptionChange = (description) => {
    _d(onSeoSettingChange({ description }));
  };
  const handleSlugOnChange = ({ slug, valid }) => {
    _d(onSeoSettingChange({ urlSlug: slug, slugValid: valid }));
  };
  return (
    <SectionContent>
      <Row
        elements={[
          {
            child: (
              <ItemWrapper
                rightPart={
                  <CountWords count={(title || '').length} allCount={100} />
                }
                title={getI18n('legalPage.index.pageTitle')}
                id='SalesChannelLegalPageEditorSeoSettingSlug'>
                <Input
                  maxLength={100}
                  onChange={handleOnTitleChange}
                  value={title}
                  size='large'
                  disabled={!canEdit || props?.disabled}
                />
              </ItemWrapper>
            ),
          },
          {
            child: isPrimary ? (
              <Slug
                //containerClassName={css.slugContainer}
                value={urlSlug}
                displayDangerousNotice
                url={'portal/salesChannel/legalPage/checkSlug'}
                slugValid={slugValid}
                fixedParams={{
                  salesChannelUuid: uuid,
                  pageUuid: legalPageUuid === NEW ? null : legalPageUuid,
                }}
                onChange={handleSlugOnChange}
                disabled={!canEdit}
              />
            ) : (
              <React.Fragment />
            ),
          },
        ]}
      />
      <Row
        elements={[
          {
            child: (
              <ItemWrapper
                title={getI18n('general.upload.EditModal.description')}
                rightPart={
                  <CountWords
                    count={(description || '').length}
                    allCount={500}
                  />
                }>
                <TextArea
                  maxLength={500}
                  onChange={handleOnDescriptionChange}
                  value={description}
                  disabled={!canEdit || props?.disabled}
                />
              </ItemWrapper>
            ),
          },
          { child: <React.Fragment /> },
        ]}
      />
    </SectionContent>
  );
};

export default SectionHOC(SeoSetting, {
  id: EnumCollapseId.SeoSetting,
  title: getI18nFromGeneral('general.hOCTitle.sEOSetting'),
  getCollapse,
  onCollapseChange,
});
